import { TEMPLATE_MAP, MOB_TEMPLATES, reverseTemplateMap } from '@/store/modules/irstore';

// -------------------- 投关总结
const EnterpriseSummary = () => import(/*webpackChunkName: "EnterpriseSummary" */ '@/view/enterprise/summary');
export const ENTERPRISE_SUMMARY_ROUTERS = [
	{
		path: 'enterprise/summary',
		name: 'enterprise_summary',
		component: EnterpriseSummary,
		meta: {
			noAuthor: true
		}
	}
];

// -------------------- 图片预览
const EnterpriseImagePreview = () =>
	import(/*webpackChunkName: "EnterpriseImagePreview" */ '@/view/enterprise/image-preview');
// -------------------- 中转页
const EnterpriseMiddleBack = () =>
	import(/*webpackChunkName: "EnterpriseMiddleBack" */ '@/view/enterprise/middle-back.vue');
export const ENTERPRISE_TOOLS_ROUTERS = [
	{
		path: 'enterprise/preview',
		name: 'enterprise_preview',
		component: EnterpriseImagePreview,
		meta: {
			title: '图片预览',
			noAuthor: true
		}
	},
	{
		path: 'enterprise/middle-back',
		name: 'enterprise_middle_back',
		component: EnterpriseMiddleBack,
		meta: {
			title: '',
			noAuthor: true
		}
	}
];

// -------------------- 历史路由重定向
export const ENTERPRISE_LEGACY_ROUTES = [
	// 定制入口
	{
		path: 'enterprise/:channel(tmpl_nine|tmpl_ebmedical)',
		redirect: to => {
			const { channel } = to.params;
			return {
				path: `enterprise/tmpl/${channel.replace(/^tmpl_/, '')}_index`,
				query: to.query
			};
		}
	},

	// 模块路由
	{
		path: 'enterprise/:moduleId/:subPath?',
		redirect: to => {
			const { moduleId, subPath } = to.params;
			const { pageType, tmplId, ...otherQuery } = to.query;

			const reversedTemplateMap = reverseTemplateMap(TEMPLATE_MAP);
			// 根据 pageType 决定模板类型, 默认卡片式移动端: tmpl
			const tmplType = reversedTemplateMap[pageType] || 'tmpl';

			let realModuleId = moduleId;
			if (moduleId === 'custom' && to.query.moduleId) {
				realModuleId = to.query.moduleId;
			}

			// 重定向过程中会被冒号解析导致指向根路径，所需需要兼容带冒号的链接场景
			let originalRealModuleId = realModuleId;
			if (realModuleId.includes(':')) {
				realModuleId = 'unknow';
			}

			// 构建目标路径
			let tmplPath;
			if (tmplType === 'cardM') {
				tmplPath = `${tmplType}/${tmplId}`;
			} else {
				tmplPath = tmplType;
			}
			const basePath = `enterprise/${tmplPath}/${realModuleId}`;
			const buildPath = subPath ? `${basePath}/${subPath}` : basePath;

			// 非移动端模板访问时，需要在 query 中添加 pageType 参数
			const buildQuery = MOB_TEMPLATES.includes(pageType) ? otherQuery : { ...to.query };

			// 如果 realModuleId 包含冒号，添加 id 参数到 buildQuery
			if (originalRealModuleId.includes(':')) {
				buildQuery.id = originalRealModuleId;
			}

			return {
				path: buildPath,
				query: buildQuery
			};
		}
	}
];
